<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <h4 class="modal-card-title">
        {{type === 'cancel' ? 'Cancel' : 'Delete'}} Delivery
      </h4>
    </header>
    <section class="modal-card-body is-size-4 p-0">
        <div class="column pt-2">
            <label class="label is-italic">Delivery</label>
            <div class="field-body line-height">
              {{ rowData.name }}
            </div>

            <label class="label is-italic mt-4">Destination Project</label>
            <div class="field-body">
                <span>{{ $_.get(rowData, 'delivery.deliveryProject.name', '') }}</span>
              </div>
            <label class="label is-italic mt-4">Destination Location</label>
            <div class="field-body">
                <span>{{ $_.get(rowData, 'delivery.deliveryLocation.name', '') }}</span>
            </div>
            <div class="columns mt-2">
                <div class="column">
                    <div class="field">
                    <div class="field-label">
                        <label class="label">Ship Date</label>
                    </div>
                    <div class="field-body">
                        <field-date 
                        :item="rowData" 
                        :input-props="{
                            kind: 'delivery.deliveryStart', 
                        }" 
                        :is-edit="false"></field-date>
                    </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                    <div class="field-label">
                        <label class="label">Delivery Date</label>
                    </div>
                    <div class="field-body">
                        <field-date 
                        :item="rowData" 
                        :input-props="{
                            kind: 'delivery.deliverBy', 
                        }" 
                        :is-edit="false"></field-date>
                    </div>
                    </div>
                </div>
            </div>
            <div class="is-divider my-0 mb-4"></div>
            <div class="field mb-2">
                <div class="field-label mb-2">
                    <label class="label">{{ type === 'cancel' ? 'Cancel': 'Delete'}} Delivery ?</label>
                </div>
                <div class="field-body">
                    <p v-if="type === 'cancel'" class="line-height">Cancelling this delivery will clear the <span class="has-text-weight-bold">“Ship Date”</span> and return the delivery to the <span class="has-text-weight-bold">“Unscheduled”</span> state.</p>
                    <p v-else  class="line-height"> All items and item quantities in this delivery will be set to <span class="has-text-weight-bold"> “Not Scheduled”</span> and the delivery will be deleted.</p>
                </div>
            </div>
        </div>
       
    </section>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <button class="button is-outlined" @click="cancel()">Cancel</button>
      <button class="button has-background-black-bis"
              @click="updateDelivery()">{{ type === 'cancel' ? 'Cancel': 'Delete'}} Delivery </button>
      </footer>
  </div>
  <o-loading
      :full-page="false"
      :active="isLoading"
      :can-cancel="true"
    ></o-loading>
</template>
<script>
import {
  reactive, toRefs, computed
} from 'vue';
 import GeneralShippingMixin from '@/components/mixins/GeneralShippingMixin';

export default {
  props: {
    rowData: Object,
    onConfirm: Function,
    type: String
  },
  setup(props, { emit }) {
    const state = reactive({
      name: props.rowData.name,
      trackingId: _.get(props.rowData, 'delivery.trackingId', ''),
      isLoading: false,
    });

    const { updateShipment } = GeneralShippingMixin();

    const disabled = computed(() => {
        return state.name === props.rowData.name && state.trackingId === _.get(props.rowData, 'delivery.trackingId', '');
    })
 
    const cancel = () => {
      emit('close');
    };


    const updateDelivery = async() => {
       try {
        state.isLoading = true;
        await props.onConfirm(); 
       } catch (error) {
        console.log(error);
        return;
       }finally {
        state.isLoading = false;
       }
       cancel();
    }

    return {
      ...toRefs(state),
      cancel,
      disabled,
      updateDelivery
    };
  },
};
</script>

<style scoped>
  .modal-card-body {
    overflow: visible;
  }
   .modal-card-head {
    background-color: #fff !important;
    border-bottom: none !important;
  }
  .modal-card-foot {
    border-top: 1px solid #84888c;
     background-color: #fff !important;
  }
</style>
